import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../config";
import NavBar from "./NavBar";

function AdminDashboard() {
  const [withdrawalStats, setWithdrawalStats] = useState({
    total: 0,
    approved: 0,
    pending: 0,
    rejected: 0,
    totalAmount: 0,
  });

  const [depositStats, setDepositStats] = useState({
    total: 0,
    approved: 0,
    pending: 0,
    rejected: 0,
    totalAmount: 0,
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        // Fetch Withdrawals
        const withdrawalSnapshot = await getDocs(collection(db, "withdrawals"));
        let w_total = 0,
          w_approved = 0,
          w_pending = 0,
          w_rejected = 0,
          w_totalAmount = 0;

        withdrawalSnapshot.forEach((doc) => {
          const data = doc.data();
          w_total++;
          if (data.status === "approved") w_approved++;
          else if (data.status === "pending") w_pending++;
          else if (data.status === "rejected") w_rejected++;
          w_totalAmount += parseFloat(data.amount) || 0;
        });

        setWithdrawalStats({
          total: w_total,
          approved: w_approved,
          pending: w_pending,
          rejected: w_rejected,
          totalAmount: w_totalAmount,
        });

        // Fetch Deposits
        const depositSnapshot = await getDocs(collection(db, "deposits"));
        let d_total = 0,
          d_approved = 0,
          d_pending = 0,
          d_rejected = 0,
          d_totalAmount = 0;

        depositSnapshot.forEach((doc) => {
          const data = doc.data();
          d_total++;
          if (data.status === "approved") d_approved++;
          else if (data.status === "pending") d_pending++;
          else if (data.status === "rejected") d_rejected++;
          d_totalAmount += parseFloat(data.amount) || 0;
        });

        setDepositStats({
          total: d_total,
          approved: d_approved,
          pending: d_pending,
          rejected: d_rejected,
          totalAmount: d_totalAmount,
        });
      } catch (err) {
        console.error("Error fetching stats:", err);
      }
    };

    fetchStats();
  }, []);

  return (
    <div className="container py-5">
      {/* Admin Header/Navbar */}
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a className="nav-link" data-widget="pushmenu" href="#" role="button">
              <i className="fas fa-bars" />
            </a>
          </li>
        </ul>
      </nav>
      <NavBar />

      {/* Withdrawal Section */}
      <h2 className="mb-4 text-center fw-bold text-uppercase">Withdrawal Stats</h2>
      <div className="row g-4 mb-5">
        <StatCard title="Total Withdrawals" value={withdrawalStats.total} icon="fa-wallet" color="primary" />
        <StatCard title="Approved" value={withdrawalStats.approved} icon="fa-check-circle" color="success" />
        <StatCard title="Pending" value={withdrawalStats.pending} icon="fa-clock" color="warning" />
        <StatCard title="Rejected" value={withdrawalStats.rejected} icon="fa-times-circle" color="danger" />
        <StatCard
          title="Total Withdrawn Amount"
          value={`$${withdrawalStats.totalAmount.toFixed(2)}`}
          icon="fa-dollar-sign"
          color="dark"
          col="6"
        />
      </div>

      {/* Deposit Section */}
      <h2 className="mb-4 text-center fw-bold text-uppercase">Deposit Stats</h2>
      <div className="row g-4">
        <StatCard title="Total Deposits" value={depositStats.total} icon="fa-piggy-bank" color="info" />
        <StatCard title="Approved" value={depositStats.approved} icon="fa-check-circle" color="success" />
        <StatCard title="Pending" value={depositStats.pending} icon="fa-clock" color="warning" />
        <StatCard title="Rejected" value={depositStats.rejected} icon="fa-times-circle" color="danger" />
        <StatCard
          title="Total Deposited Amount"
          value={`$${depositStats.totalAmount.toFixed(2)}`}
          icon="fa-dollar-sign"
          color="secondary"
          col="6"
        />
      </div>
    </div>
  );
}

// Reusable Card Component
function StatCard({ title, value, icon, color, col = "3" }) {
  return (
    <div className={`col-md-${col}`}>
      <div className={`card border-0 shadow-sm bg-${color} text-white h-100`}>
        <div className="card-body d-flex align-items-center justify-content-between">
          <div>
            <h6 className="text-uppercase fw-semibold mb-1">{title}</h6>
            <h3 className="fw-bold mb-0">{value}</h3>
          </div>
          <i className={`fas ${icon} fa-2x opacity-75`}></i>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
